export default {
  // Survey data
  survey: null,
  currentQuestionNumber: 0,
  surveyResult: null,

  // Survey UI states
  showSurveyVerification: false,
  showSurveyResults: false,
  showSurvey: false,

  // Loading states
  isLoading: {
    getSurveys: false,
    surveyAnswers: false,
    surveyResults: false,
  },

  // Error states
  errors: {
    getSurveys: null,
    surveyAnswers: null,
    surveyResults: null,
  },

  // Deprecated fields (for backward compatibility)
  isGetSurveyPending: false,
  errorOfGetSurveyFail: null,
};
